import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { NzTreeNodeBuiltinCheckboxComponent } from "ng-zorro-antd/tree";

@Component({
  selector: "ui-tree-node-checkbox[builtin]",
  templateUrl: "tree-node-checkbox.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiTreeNodeBuiltinCheckboxComponent extends NzTreeNodeBuiltinCheckboxComponent {
  @Input("uiSelectMode") public nzSelectMode = false;
  @Input() public isChecked?: boolean;
  @Input() public isHalfChecked?: boolean;
  @Input() public isDisabled?: boolean;
  @Input() public isDisableCheckbox?: boolean;
}
